export const MUNI_CATEGORIES = [
    {display:'General Obligation', value:'holdMuniType=G'},
    {display:'Revenue', value:'holdMuniType=R'},
    {display:'Refunded', value:'holdRefundInd=Y'},
    {display:'Pre-Refunded', value:'holdRefundType=PRE', oneOf:'holdRefundInd=Y'},
    {display:'Escrowed to maturity', value:'holdRefundType=ETM', oneOf:'holdRefundInd=Y'},
].map(a => {
    a.label = a.display
    return a
})


export const MUNI_CATEGORY_LABELS = {
    "R": "Revenue",
    "G": "General Obligation",
}


// WEBPACK FOOTER //
// ./src/twd/values/muni-categories.js